// @flow
import { Grid } from 'semantic-ui-react';
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';

import { SelectField, BooleanSelectField } from '../../../formik-utils/FormFields';
import { getDropdownOptions } from '../../stream-governance/utils';
import { EstimateCommittedCapacityMetadataContext } from '../../../contexts/EstimateCommittedCapacityMetadataContext';
import { useIsUserAdmin } from '../../../custom-hooks/useIsUserAdmin';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import {
  getDimensionFieldPathForEstimateCC,
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
} from '../utils';

export const ConnectDimensionColumnsForEstimateCC = ({ metricIndex, dimensionIndex, row }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const isUserAdmin = useIsUserAdmin();

  const providerPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME
  );
  const connectorNamePath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.CONNECTOR_NAME_BACKEND_FIELD_NAME
  );
  const denserBinPackingPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.IS_DENSER_BIN_PACKING_BACKEND_FIELD_NAME
  );

  const providerColConfig = {
    backendFieldName: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME,
    displayNameCol: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_LABEL_DISPLAY_NAME_COL,
    parentFieldsInGroup: [],
  };

  const connectorNameColConfig = {
    backendFieldName: ESTIMATE_COMMITTED_CAPACITY.CONNECTOR_NAME_BACKEND_FIELD_NAME,
    displayNameCol: ESTIMATE_COMMITTED_CAPACITY.CONNECTOR_LABEL_DISPLAY_NAME_COL,
    parentFieldsInGroup: [ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME],
  };

  const dataUniverse =
    useContext(EstimateCommittedCapacityMetadataContext)?.committed_connect_capacity_configs ?? [];

  const providerDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    providerColConfig,
    false,
    false,
    false,
    true
  );

  const connectorNameDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    connectorNameColConfig,
    false,
    false,
    false,
    true
  );

  const shouldColumnBeDisabled = !getIfGivenRowIsANewlyAddedRowForEstimateCC(row);

  return (
    <>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.PROVIDER_DISPLAY_NAME}
          fieldName={providerPath}
          onChange={async () => {
            await setFieldValue(connectorNamePath, null);
            await setFieldTouched(connectorNamePath, true);
          }}
          options={providerDropDownOptions}
        />
      </Grid.Column>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.CONNECTOR_NAME_DISPLAY_NAME}
          fieldName={connectorNamePath}
          options={connectorNameDropDownOptions}
        />
      </Grid.Column>
      {isUserAdmin && (
        <Grid.Column width={2}>
          <BooleanSelectField
            addLabel={false}
            disableOnFormErrors={false}
            disabled={shouldColumnBeDisabled}
            fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.IS_DENSER_BIN_PACKING_DISPLAY_NAME}
            fieldName={denserBinPackingPath}
          />
        </Grid.Column>
      )}
    </>
  );
};
